import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/animation.svg
 */
const IconAnimation: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M0 21.059h8.466V19.91h-1.77v-1.72h1.77v-1.147H1.155v-6.309h7.311V9.588H6.7V7.962h1.767V6.814H.006L0 21.059zM3.824 7.96h1.72v1.626h-1.72V7.96zm-2.676 0h1.53v1.626h-1.53V7.96zm2.676 10.23h1.72v1.72h-1.72v-1.72zm-2.676 0h1.53v1.72h-1.53v-1.72zM10.754 6.814V7.96h1.675v1.626h-1.675v1.148h7.457v6.309h-7.457v1.147h1.675v1.72h-1.675v1.149H24v-4.016h-4.637v-6.309H24v-3.92H10.754zm4.541 2.772h-1.72V7.96h1.72v1.626zm2.87 0h-1.723V7.96h1.722v1.626zm-2.87 10.324h-1.72v-1.72h1.72v1.72zm2.87 0h-1.723v-1.72h1.722v1.72zm4.015-1.72h.668v1.72h-.668v-1.72zm-1.149 0v1.72h-1.673v-1.72h1.673zm0-8.604h-1.673V7.96h1.673v1.626zm1.817 0h-.668V7.96h.668v1.626z"
      fill="currentColor"
    />
    <path
      d="M12.5 1.604A1.15 1.15 0 0011.354.457H7.863a1.148 1.148 0 00-1.147 1.147V3.05l2.318 1.463v19.03h1.149V4.513L12.5 3.051V1.604z"
      fill="currentColor"
    />
  </svg>
);

export default IconAnimation;
